<div class="main-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header card-header-primary">
            <div class="row">
              <div class="col-8 d-flex align-items-center gap-3">
                <div>
                  <h4 class="card-title mt-0">Expense List</h4>
                  <p class="card-category">Manage your expenses</p>
                </div>
                <div class="flex-grow-1" style="max-width: 300px;">
                  <app-search [(value)]="searchTerm"
                              (valueChange)="onSearchChange()"
                              placeholder="Search">
                  </app-search>
                </div>
              </div>
              <div class="col-4 text-end">
                <button mat-raised-button type="button" class="btn btn-success pull-right" [routerLink]="['/expenses/create']">Add New Expense</button>
              </div>
            </div>
          </div>

          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-hover table-striped">
                <thead class=" text-primary">
                    <th>ID</th>
                    <th>Client</th>
                    <th>Case</th>
                    <th style="width: 130px;">Diary</th>
                    <th>Type</th>
                    <th>Amount</th>
                    <th>Description</th>
                    <th style="width: 130px;">Date</th>
                    <th>Actions</th>
                </thead>
                <tbody>
                  <tr *ngFor="let expense of expenses">
                    <td>{{ expense.id }}</td>
                    <td>{{ expense.client?.fullName || '-' }}</td>
                    <td>{{ expense.case?.caseNumber || '-' }}/{{ expense.case?.year || '-' }}</td>
                    <td>{{ expense.diary?.hearingDate ? (expense.diary?.hearingDate | date:'EEE, dd-MMM-yyyy') : '-' }}</td>
                    <td>{{ expense.expenseType || '-' }}</td>
                    <td>{{ expense.amount ? (expense.amount | currency:'PKR':'symbol':'1.0-0')?.replace('PKR', 'PKR ') : '-' }}</td>
                    <td>{{ expense.description || '-' }}</td>
                    <td>{{ expense.expenseDate ? (expense.expenseDate | date:'EEE, dd-MMM-yyyy') : '-' }}</td>
                    <td>
                      <i class="material-icons text-danger" style="cursor: pointer;" (click)="deleteExpense(expense.id)">delete</i>
                      <i class="material-icons text-warning" style="cursor: pointer;" [routerLink]="['/expenses/edit', expense.id]">edit</i>
                    </td>
                  </tr>
                </tbody>
              </table>

              <mat-paginator [length]="totalItems"
                             [pageSize]="pageSize"
                             [pageSizeOptions]="[5, 10, 25, 50]"
                             (page)="onPageChange($event)">
              </mat-paginator>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
